import { AT } from '../../../actions/actionTypes';
import { FeedbackAddPL } from '../../../models';
import { Panels } from '../model';
import * as DeviceInfo from '.';
import { Item, HistoricalPL, KeyPL, FullInfoPL } from './model';
// import { ErrorDataResponse } from '../../../core/apis/mykeys/exceptions';
import * as Devices from '../../devices';
import * as MyKeysApiDevices from '../../../core/apis/mykeys/devices';
import { LMessage } from '../../../core/localization';
import { setRightPanel } from '../actions';
import { doAction } from '../../../core/redux/store';
import { MyKeysPromiseMap } from '../../../core/apis/mykeys/mappings';
import {getOldestDate, getNewstDate } from '../../historical';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const openDialog = () => setRightPanel(Panels.DEVICE_DETAILS);
export const openLogsDialog = () => setRightPanel(Panels.DEVICE_LOGS);

export const initDialog = (key: string) => {
  Logger.info(['openDeviceInfoDialog', key], LogArea.Redux);
  const pkey = Devices.parsePK(key);
  if (pkey) {
    doAction<DeviceInfo.KeyPL>(AT.DIALOG_DEVICEINFO_KEY_UPDATED, pkey);
    openDialog();
  }
  Logger.warn(['key is not wellformated', key]);
};

export const getDeviceInfo = (device: Devices.Device) => {
  Logger.info(['getDeviceInfo', device], LogArea.Redux);
  MyKeysApiDevices.getDeviceInfo(device)
    .then(MyKeysPromiseMap)
    .then((data: Devices.DeviceExtendedWithHistoricalData) =>
      doAction<FullInfoPL>(AT.DIALOG_DEVICEINFO_SUCCESS, data)
    )
    .catch((/* err: ErrorDataResponse */) => {
      const messages: LMessage[] = [DeviceInfo.msgDeviceInfoError(device)];
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, { content: messages });
      doAction<KeyPL>(AT.DIALOG_DEVICEINFO_ERROR, device);
    });

  doAction<Devices.Device>(AT.DIALOG_DEVICEINFO_FETCH, device);
};

export const getItem = (key: string, items: Item[], data: Devices.Data) => {
  const device = Devices.getItemByPK(Devices.getLoadedDevices(data.pages), key);
  if (!device) return undefined;
  const item = Devices.getItemByPK(items, String(key));
  if (item) {
    return { ...item, ...device, ...Devices.DeviceExtensionMap(item) };
  }
  getDeviceInfo(device);
  return undefined;
};
export const getLatestLogs = (item: DeviceInfo.Item) => {
  Logger.info(['getLatestLogs', item], LogArea.Redux);
  const firstLogDate = getNewstDate(item.historicalLogs.logs);

  MyKeysApiDevices.getDeviceLogs(item, firstLogDate)
    .then(MyKeysPromiseMap)
    .then((data: Devices.DeviceExtendedWithHistoricalData) =>
      doAction<HistoricalPL>(AT.DIALOG_DEVICEINFO_LATESTLOGS_SUCCESS, {
        device: data,
        historical: data.historicalLogs,
      })
    )
    .catch((/* err: ErrorDataResponse */) => {
      const messages: LMessage[] = [DeviceInfo.msgDeviceInfoError(item)];
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, { content: messages });
      doAction<KeyPL>(AT.DIALOG_DEVICEINFO_LATESTLOGS_ERROR, item);
    });
  doAction<DeviceInfo.Item>(AT.DIALOG_DEVICEINFO_LATESTLOGS_FETCH, item);
};

export const getMoreLogs = (item: DeviceInfo.Item) => {
  Logger.info(['getDeviceHistory', item], LogArea.Redux);
  if (item.historicalLogs.total === item.historicalLogs.logs.length) return;

  const lastLogDate = getOldestDate(item.historicalLogs.logs);
  MyKeysApiDevices.getDeviceLogs(item, undefined, lastLogDate)
    .then(MyKeysPromiseMap)
    .then((data: Devices.DeviceExtendedWithHistoricalData) =>
      doAction<HistoricalPL>(AT.DIALOG_DEVICEINFO_MORELOGS_SUCCESS, {
        device: data,
        historical: data.historicalLogs,
      })
    )
    .catch((/* err: ErrorDataResponse */) => {
      const messages: LMessage[] = [DeviceInfo.msgDeviceInfoError(item)];
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, { content: messages });
      doAction<KeyPL>(AT.DIALOG_DEVICEINFO_MORELOGS_ERROR, item);
    });

  doAction<DeviceInfo.Item>(AT.DIALOG_DEVICEINFO_MORELOGS_FETCH, item);
};
